import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "./index.css";
import App from "./App";

import { Provider } from "react-redux";
import { store } from "./redux/store";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./query";
import { initMixpanel } from "./config/mixpanel";
import { initGTM } from "./config/gtm";

initMixpanel();
initGTM();

const container = document.getElementById("root");
const appElement = (
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </Provider>
);

if (container && container.hasChildNodes() && container.innerHTML.trim().length > 0) {
  hydrateRoot(container, appElement);
} else if (container) {
  createRoot(container).render(appElement);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
